import { createAction } from 'redux-actions';
// fetch new i18n data
export let switchLanguage = createAction('SWITCH_LANGUAGE', (language)=>({
        language
    }));
// reload domain i18n layer for a specific domain/language combo
export let reloadLanguage = createAction('RELOAD_LANGUAGE', ({ language, dname })=>({
        language,
        dname
    }));
// make switched language active
export let setLanguage = createAction('SET_LANGUAGE', ({ language, dname, i18ndata, cacheKeys, merged = {} })=>({
        language,
        dname,
        i18ndata,
        cacheKeys,
        merged
    }));
export let updateBaseLanguage = createAction('UPDATE_BASE_LANGUAGE', (bundle)=>({
        bundle
    }));
